import script from "./studyList.vue?vue&type=script&setup=true&lang=js"
export * from "./studyList.vue?vue&type=script&setup=true&lang=js"

import "./studyList.vue?vue&type=style&index=0&id=15355067&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15355067"]])

export default __exports__